export const DeviationMainCategory = {
	receiving: 0,
	in_house: 1,
	in_goods: 2,
};
